import { GET_ENC, POST_ENC } from "./common/EncryptedHttp";
import { BASE_URL } from "./common/const";

export const GetOPDCheifComplaintsDetail = (params: any) =>
  GET_ENC(`${BASE_URL}/api/OPDCheifComplaints/GetDetail?` + params, null);

export const CreateOPDCheifComplaints = (data: any) =>
  POST_ENC(`${BASE_URL}/api/OPDCheifComplaints/Create`, data);

export const UpdateOPDCheifComplaints = (data: any) =>
  POST_ENC(`${BASE_URL}/api/OPDCheifComplaints/Update`, data);
